(() => {
  const rte = document.querySelector('.shopify-policy__body .rte');
  if (!rte) return;
  const isHead = (el) => {
    if (el.tagName !== 'P') return false;
    const text = el.textContent.trim();
    const bold = [...el.querySelectorAll('b, strong')].map((b) => b.textContent).join('').trim();
    return text && bold === text && !text.includes('@') && !/^iyashi matcha$/i.test(text);
  };
  const kids = [...rte.children];
  if (kids.filter(isHead).length < 4) return;
  if (isHead(kids[0])) kids.shift().remove();
  const list = document.createElement('div');
  list.className = 'iy-pol';
  let body = null;
  for (const el of kids) {
    if (isHead(el)) {
      const d = document.createElement('details');
      const s = document.createElement('summary');
      s.textContent = el.textContent.trim();
      body = document.createElement('div');
      body.className = 'iy-pol__body';
      d.append(s, body);
      list.append(d);
      el.remove();
    } else if (body) body.append(el);
  }
  rte.append(list);
})();
